import { z } from 'zod';

import { baseEntitySchema } from './baseContract';
import { ChatRole } from '../enums';

// Base ChatMessage schema
export const chatMessageSchema = baseEntitySchema.extend({
  thread: z.string().uuid(),
  feedback: z.string().uuid().optional(),
  role: z.nativeEnum(ChatRole),
  content: z.string().optional(),
  user: z.string().uuid().optional(),
  metadata: z.record(z.any()).optional(),
  toolCalls: z.array(z.any()).optional(),
});

// Create DTO schema
export const createChatMessageSchema = chatMessageSchema
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  })
  .strict();

// Update DTO schema
export const updateChatMessageSchema = chatMessageSchema
  .partial()
  .required({
    id: true,
  })
  .strict();

export type ChatMessageDTO = z.infer<typeof chatMessageSchema>;
export type CreateChatMessageDTO = z.infer<typeof createChatMessageSchema>;
export type UpdateChatMessageDTO = z.infer<typeof updateChatMessageSchema>;
